import React, { useState } from 'react';
import styled from '@emotion/styled';
import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image"
import IconPackage from 'xiv-fanfes-2021'
import YouTube from 'react-lite-youtube-embed';
import { MDXRenderer } from "gatsby-plugin-mdx"
import { useLocalization } from "gatsby-theme-i18n";
import { Anchor } from "../StyledComponents";
import Ingedient from './Ingedient';
import { isAutoEmbedAllowed, isMacSafari } from '../../functions/common';

import RoundButton from '../RoundButton';

import * as breakpoint from '../../styles/breakpoints.module.scss';

const RecipeBlock = ({ data }) => {
  const { t, locale } = useLocalization();
  const [ showDetails, setShowDetails] = useState(false);
  const youtubePlayer = React.useRef(null);
  


  return (
    <>
    <RecipeWrapper>
      <Anchor id={data.frontmatter.slug}>{data.frontmatter.title}</Anchor>
      <Recipe>
        <UpperRow>
          <VisualBlock>
            <div>
              <VisualWrapper>
                <div className='yt-wrapper' ref={youtubePlayer}>
                  <a className="yt-link" href={data.frontmatter.movie_url} target="_blank" rel="noopener noreferrer" onClick={(e) => {
                    if(isAutoEmbedAllowed() || locale === "ja")
                    {
                      e.preventDefault();
                      youtubePlayer.current.querySelector('.lty-playbtn').click();
                      youtubePlayer.current.querySelector('a.yt-link').style.display = 'none';
                    } 
                  }}></a>
                  <YouTube id={data.frontmatter.movie_url ? data.frontmatter.movie_url.replace('https://youtu.be/','') : ''} 
                    autoplay={true}
                    aspectWidth={1}
                    aspectHeight={1} 
                    muted={isMacSafari()}
                    thumbnail={getSrc(data.frontmatter.eyecatch)}
                  />
                </div>
              </VisualWrapper>
            </div>
          </VisualBlock>
          <TextBlock>
            <div className="recipeNumber">{`${t('eorzeacafe_at_home.recipe.label')} ${t('eorzeacafe_at_home.recipe.number.prefix')}${data.frontmatter.num}`}</div>
            <div className="recipeTitle">{data.frontmatter.title}</div>
            <div className="recipeItemDetails">
              <div className="recipeJob">
                <span className="label"><IconPackage.Icon type={'Culinarian'} /></span>
                {t('eorzeacafe_at_home.recipe.job.label')} {data.frontmatter.job.level}
              </div>
              <div className="recipeIL">
                <span className="label">{t('eorzeacafe_at_home.recipe.item-level.label')}</span>
                {data.frontmatter.item_level}
              </div>
            </div>
            <div className="recipeDesc">{data.frontmatter.introduction}</div>
            <IngredientsList className={showDetails ? 'shown' : ''}>
              <div className="titleLabel">
                {t('eorzeacafe_at_home.recipe.ingredients')}
              </div>
              <div className="list">
                {data.frontmatter.ingredients.map((item,index) => 
                  <Ingedient key={`ingedient_${data.frontmatter.slug}_${index}`} item={item}/>
                )}
              </div>
            </IngredientsList>
          </TextBlock>
        </UpperRow>
        <LowerRow className={showDetails ? 'shown' : ''}>
          <div className="content">
            <div className="title">{t('eorzeacafe_at_home.recipe.method')}</div>
            <div className="step">
              <MDXRenderer>
                {data.body}
              </MDXRenderer>
            </div>
          </div>
          <DetailsButton href="#" color={'#4E4E50'} size={'medium'} onClick={(e) => {
            e.preventDefault();
            setShowDetails(true);
          }}>
            {t('eorzeacafe_at_home.recipe.more.button.label')}
            <IconPackage.Icon type={'Arrow'} />
          </DetailsButton>
        </LowerRow>
      </Recipe>
    </RecipeWrapper>
  </>);
}
 
export default RecipeBlock;


const RecipeWrapper = styled.div`
  width:100%;
  margin-bottom:48px;
  text-align:center;
  &:last-of-type{margin-bottom:0;}
`


const Recipe = styled.div`
  background: #FCFCFF;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  max-width:1344px;
  box-sizing: border-box;
  width:100%;
  padding: 96px;
  margin:0 auto;
  text-align:left;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding: 64px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding: 24px;
  }
  

`

const UpperRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap:wrap;
  max-width:1152px;
  margin:0 auto;
`

const LowerRow = styled.div`
  max-width:1152px;
  margin:auto 0;
  .title{
    font-size: 28px;
    line-height: 40px;
    font-weight: 900;
    letter-spacing: 0.03em;
    color: #2C2C2E;
    margin-bottom:32px;
    padding-top:32px;
  }
  .step{
    a{
      text-decoration:none;
      color:#D00F31;
    }
    >br{display:none;}

    .footnotes {
      hr{
        width: 100%;
        margin-bottom:32px;
        border-top: 1px dashed #CACACD;
      }

      ol{ 
        font-size: 14px;
        line-height: 28px; 
        margin-bottom:32px;
        color: #444448;
        display:block;
        margin-left:32px;
        margin-bottom:0;
        
        li{
          width:100%;
          margin-bottom:0;
          position:relative;
          list-style: outside disc;
        }
      }
    }
    > ol{
      display:flex;
      flex-wrap:wrap;
      list-style-type:none;
      margin-right:-32px;
      > br{display:none;}
      li{
        width:20%;
        padding-left:40px;
        padding-right:32px;
        margin-bottom:32px;
        position:relative;
        font-size: 16px;
        line-height: 28px;
        color: #444448;
        letter-spacing: 0.02em;

        &:before{
          content:'1';
          text-align:center;
          position:absolute;
          width:24px;
          height:24px;
          color: #D00F31;
          border: 2px solid #D00F31;
          box-sizing: border-box;
          border-radius: 16px;
          font-size: 12px;
          line-height: 19px;
          font-weight: 900;
          left:0;
        }

        &:nth-of-type(2):before{content:'2';}
        &:nth-of-type(3):before{content:'3';}
        &:nth-of-type(4):before{content:'4';}
        &:nth-of-type(5):before{content:'5';}
        &:nth-of-type(6):before{content:'6';}
        &:nth-of-type(7):before{content:'7';}
        &:nth-of-type(8):before{content:'8';}
        &:nth-of-type(9):before{content:'9';}
        &:nth-of-type(10):before{content:'10';}
        &:nth-of-type(11):before{content:'11';}
        &:nth-of-type(12):before{content:'12';}
        &:nth-of-type(13):before{content:'13';}
        &:nth-of-type(14):before{content:'14';}
        &:nth-of-type(15):before{content:'15';}
        &:nth-of-type(16):before{content:'16';}
        &:nth-of-type(17):before{content:'17';}
        &:nth-of-type(18):before{content:'18';}
        &:nth-of-type(19):before{content:'19';}
        &:nth-of-type(20):before{content:'20';}
        &:nth-of-type(21):before{content:'21';}
      }
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
   .title{
    font-size: 20px;
    line-height: 28px;
    margin-bottom:32px;
   }
   .step{
    .footnotes{
      ol{
        margin-left:40px;
      }
      hr, ol{ 
        margin-bottom:24px;
      }
    }
    > ol{
      display:block;
      margin:0;
      li{
        padding-right:0;
        width:100%;
        margin-bottom:24px;
      }
    }
   }

   text-align:center;
   .content{
     max-height:0;
     overflow:hidden;
     transition: max-height 2s;
     text-align:left;
   }

   &.shown .content{
    max-height:4000px;
   }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    .title{
      font-size: 16px;
      line-height: 24px;
      margin-bottom:16px;
    }
    .step{
      .footnotes{
        ol{
          margin-left:24px;
        }
        hr, ol{ 
          font-size: 10px;
          line-height: 20px;
          margin-bottom:16px;
        }
      }
      > ol{
        li{
          margin-bottom:16px;
          font-size: 12px;
          line-height: 20px;
          padding-left:24px;

          &:before{
            width:16px;
            height:16px;
            border:1px solid #D00F31;
            font-size: 8px;
            line-height: 14px;
            top:2px;
          }
        }
      }
    }
  }
`

const VisualWrapper = styled.span`
  display:block;
  position:relative;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 6px;
  position:relative;
  overflow:hidden;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  z-index: 1;
  padding-top:100%;


  .gatsby-image-wrapper, iframe, div.yt-wrapper,  .yt-link{
    width:100%;
    height:100%;
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
  }

  .yt-link{
    display:block;
    z-index:3;
  }

  .yt-lite{
    width: 100%;
    height: 100%;
    aspect-ratio: 1 / 1;
  }

  .lty-playbtn{
    display:block;
    position:absolute;
    width:48px;
    height:48px;
    background: #F50057;
    border-radius: 24px;
    text-align:center;
    bottom:32px;
    right:32px;
    z-index:2;
    filter: none;
    opacity: 1;
    transition: none;
    transform: none;
    top: auto;
    left: auto;


    &:before{
      content:'';
      display:block;
      width:24px;
      height:24px;
      background:#FFFFFF;
      clip-path: polygon( 100% 44.85%,100% 44.85%,101.714% 45.898%,103.047% 47.166%,103.999% 48.6%,104.57% 50.144%,104.761% 51.743%,104.57% 53.343%,103.999% 54.887%,103.047% 56.321%,101.714% 57.589%,100% 58.637%,14.286% 100%,14.286% 100%,12.343% 100.717%,10.363% 101.048%,8.401% 101.021%,6.515% 100.663%,4.763% 100.001%,3.2% 99.063%,1.886% 97.878%,0.876% 96.471%,0.229% 94.871%,0% 93.106%,0% 10.381%,0% 10.381%,0.229% 8.615%,0.876% 7.016%,1.886% 5.609%,3.2% 4.423%,4.763% 3.486%,6.515% 2.824%,8.401% 2.466%,10.363% 2.438%,12.343% 2.769%,14.286% 3.487%,100% 44.85% );
      margin:12px;
    }

    @media only screen and (max-width: ${breakpoint.smMax}){
      bottom:24px;
      right:24px;

      &:before{
        width:20px;
        height:20px;
        margin:14px;
      }
    }

    @media only screen and (max-width: ${breakpoint.xsMax}){
      bottom:16px;
      right:16px;
      width:32px;
      height:32px;
      
      &:before{
        width:12px;
        height:12px;
        margin:10px;
      }
    }
  }
`

const VisualBlock = styled.div`
  width:calc(50% - 24px);
  display:block;
  position:relative;
  > div{
    position:relative;
  }
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    margin-bottom:48px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:16px;
  }
`

const TextBlock = styled.div`
  width:calc(50% - 24px);
  position: relative;
  z-index:2;
  .recipeNumber{
    color: #D00F31;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.03em;
    font-weight: 900;
    margin-bottom:12px;
  }
  .recipeTitle{
    font-weight: 900;
    font-size: 48px;
    line-height: 56px;
    letter-spacing: 0.03em;
    font-weight: 900;
    margin-bottom:16px;
    color: #2C2C2E;
  }

  .recipeItemDetails{
    font-size: 14px;
    line-height: 24px;
    color: #787880;
    margin-bottom:16px;
    > div{
      display:inline-block;
      margin-right:16px;
      .label{
        margin-right:8px;
        display:inline-block;
      }
      svg{
        width:24px;
        height:24px;
        vertical-align:middle;
      }
    }
  }

  .recipeDesc{
    background: #FFECB3;
    border-radius: 12px;
    padding: 24px;
    color: #222224;
    font-size: 14px;
    line-height: 24px;
    margin-bottom:56px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    .recipeNumber{
      font-size: 12px;
      line-height: 16px;
      margin-bottom:4px;
    }
    .recipeTitle{
      font-size: 28px;
      line-height: 36px;
    }
    .recipeDesc{
      margin-bottom:32px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    .recipeNumber{
      font-size: 10px;
      line-height: 14px;
      margin-bottom:0px;
    }
    .recipeTitle{
      font-size: 20px;
      line-height: 28px;
    }
    .recipeItemDetails{
      font-size: 12px;
      line-height: 24px;
    }
    .recipeDesc{
      padding:16px;
      font-size: 12px;
      line-height: 20px;
      margin-bottom:24px;
    }
  }
`

const IngredientsList = styled.div`
  .titleLabel{
    font-weight: 900;
    font-size: 28px;
    line-height: 40px;
    color: #2C2C2E;
    margin-bottom:32px;
  }
  .list{
    display:flex;
    justify-content:space-between;
    flex-wrap: wrap;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    .titleLabel{
      font-size: 20px;
      line-height: 28px;
    }

    max-height:0;
    overflow:hidden;
    transition: max-height 2s;
    &.shown{
      max-height:4000px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    .titleLabel{
      font-size: 16px;
      line-height: 24px;
      margin-bottom:16px;
    }
  }

`


const DetailsButton = styled(RoundButton)`
  margin:0 auto;
  height:auto;
  
  svg{
    transform: rotate(90deg);
    vertical-align: bottom;
  }
  @media only screen and (min-width: ${breakpoint.mdMin}){
    display:none;
  }

  .shown &{display:none;}

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:0 auto;
    height:auto;
    padding:12px 24px;
    border-radius:24px;
    svg{
      margin-left:12px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:0 auto;
    height:auto;
    padding:8px 16px;
    svg{
      margin-left:5px;
    }
  }
`
